import {wrappedFetch} from "./Functions";
import {apiUrl} from "./apiUrl";

export const getRole = ()=> localStorage.getItem('role')
export const storeRole = (e)=> localStorage.setItem('role', e)
export const getToken = ()=> localStorage.getItem('token')
export const storeToken = (e)=> localStorage.setItem('token', e)
export const storeEmail = (e)=> localStorage.setItem('id', e)
export const getEmail= ()=> localStorage.getItem('id')
export const storePw = (e)=> localStorage.setItem('pw', e)
export const getPw= ()=> localStorage.getItem('pw')

export const getUserId = async ()=> {
    const r = await wrappedFetch('/auth/id')
    return await r.text();
}

export const logout = ()=> {
    localStorage.removeItem('id')
    localStorage.removeItem('pw')
    localStorage.removeItem('role')
}

export const login = async (email, pw) => {
    return fetch(apiUrl+'/auth/login', {
        method: 'POST',
        body: JSON.stringify({email, pw}),
        headers: {'Content-Type': 'application/json'}
    })
        .then(async res=> {
            if (res.ok) return await res.json()
            else {
                const error = await res.text()
                throw new Error(error)
            }
        })
        .then(res=> {
            storeToken(res.token)
            storeRole(res.role)
            storeEmail(email)
            storePw(pw)
            return res
        });
}